import React, { lazy } from 'react';

const TransferMethodComponent = lazy(() =>
  import(
    /* webpackChunkName: "carvana-purchase-transfer-method" */ '../transfer-method'
  )
);

export const TransferMethodRoute = () => {
  return <TransferMethodComponent />;
};
